import { useWeb3React } from "@web3-react/core"
import { useRef, useState } from "react"
import useBloodAllowance from "web/hooks/useBloodAllowance"
import useBloodToken from "web/hooks/useBloodToken"
import useEnvironment from "web/hooks/useEnvironment"
import { PolygonAddresses } from "web/lib/contract"

export default function AllowanceButton({ contractAddress = PolygonAddresses.BloodShop }) {
  const { isBeta } = useEnvironment()
  const { active } = useWeb3React()
  const { allowance } = useBloodAllowance(contractAddress)
  const [isApproving, setIsApproving] = useState<boolean>(false)

  const { handleApproval } = useBloodToken()

  async function onApproveClick() {
    setIsApproving(true)
    await handleApproval(contractAddress)
    setIsApproving(false)
  }

  return <>
    {/* Approving */}
    {isBeta && active && allowance.lte(0) && !isApproving &&
      <button className="primaryButton uppercase" onClick={onApproveClick}>
        Approve
      </button>
    }

    {isBeta && active && allowance.lte(0) && isApproving &&
      <button className="primaryButtonAlt uppercase" disabled={true}>
        Approving ...
      </button>
    }
  </>
}